/**
 * @author lihh
 * @description 进行时间戳转换
 * @param type 1:表示只要年月日 2:去掉秒
 */
const timestampFormat = (data, type = '1') => {

    // 判断是否空
    if (data === null || data === '') return '时间不限';

    // 判断是否有指定类型
    switch(type) {
        case '1': 
            return data.split(' ')[0];
        case '2':
            return data.split(':').reverse().splice(1).reverse().join(':');
        case '3': 
            // 去掉秒
            let newTime = timestampFormat(data, '2');
            // 用空格拆分数组
            let newArr = newTime.split(' ');
            let newArr1 = newArr[0].split('-');
            return `${newArr1[0]}年${newArr1[1]}月${newArr1[2]}日 ${newArr[1]}`
        case '4':
            // 用空格拆分数组
            newArr = data.split(' ');
            newArr1 = newArr[0].split('-');
            return `${newArr1[0]}年${newArr1[1]}月`
        case '5':
            let temp1 = data.split(' ')[1].split(':');
            return `${temp1[0]}:${temp1[1]}`
        case '6': 
            // 去掉秒
            newTime = timestampFormat(data, '2');
            // 用空格拆分数组
            newArr = newTime.split(' ');
            newArr1 = newArr[0].split('-');
            return `${newArr1[1]}-${newArr1[2]} ${newArr[1]}`
        case '7': 
            // 去掉秒
            newTime = timestampFormat(data, '2');
            // 用空格拆分数组
            newArr = newTime.split(' ');
            newArr1 = newArr[0].split('-');
            return `${newArr1[0]}年${newArr1[1]}月${newArr1[2]}日`
        default :
            return data;
    }
};

export default timestampFormat;


// WEBPACK FOOTER //
// ./src/filters/TimestampFormat/index.js